import { Box, type BoxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import BackgroundIllustration from './BackgroundIllustration';

function UnknownErrorIllustration({ ...other }: BoxProps) {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  return (
    <Box {...other}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 480 360"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
      >
        <BackgroundIllustration />

        <image
          href="/assets/illustrations/characters/character_6.png"
          height="300"
          x="205"
          y="30"
        />

        <path
          fill="#FFAB00"
          d="M111.1 141.2c58.7-1 58.6-88.3 0-89.2-58.6 1-58.6 88.3 0 89.2z"
          opacity="0.12"
        />

        <path
          fill="#FFD666"
          d="M111.1 120c30.8-.5 30.8-46.3 0-46.8-30.8.5-30.8 46.3 0 46.8z"
        />

        <path
          fill={PRIMARY_MAIN}
          d="M425.6 118.2c0-5-4.6-9-9.6-8.2-2-3.7-6-6-10.2-5.9 4.3-21.4-30-21.4-25.7 0-8.7-.8-15.1 9.4-10.4 16.8 2.1 3.5 5.9 5.6 10 5.5h38.7v-.1c4.1-.4 7.2-3.9 7.2-8.1zM104.3 200c.1-4.2-4.1-7.8-8.2-7-1.7-3.2-5.1-5.1-8.8-5 3.8-18.4-25.8-18.4-22 0-7.4-.7-12.9 8.1-8.9 14.4 1.8 3 5.1 4.8 8.6 4.7h33.2v-.1c3.4-.4 6.1-3.4 6.1-7z"
          opacity="0.08"
        />

        <defs>
          <linearGradient
            id="paint0_linear_1_119"
            x1="78.3"
            x2="78.3"
            y1="187.77"
            y2="305.935"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={PRIMARY_LIGHT} />
            <stop offset="1" stopColor={PRIMARY_DARK} />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
}

export default memo(UnknownErrorIllustration);
